import { useContext, useEffect, useState, type FC } from "react";
import MainLayout from "../components/MainLayout";
import { IconButton } from "rsuite";
import PlusIcon from "@rsuite/icons/Plus";
import { SearchContext } from "../contexts/SearchContext";
import { LoadingContext } from "../contexts/LoadingContext";
import { PaginationResponse } from "../objects/pagination";
import { PriceCategory } from "../models/inventory/price_category";
import { createPriceCategory, deletePriceCategory, getPriceCategories, updatePriceCategory } from "../services/inventory/PriceCategoryApi";
import { getPagination } from "../utils/helper";
import { errorToast } from "../utils/helper-ui";
import { Table, Pagination } from "rsuite";
import { BsTrash3 } from "react-icons/bs";
import PriceCategoryForm from "../components/features/inventory/PriceCategoryForm";
const { Column, HeaderCell, Cell } = Table;
interface PriceCategoryPageProps {}

const PriceCategoryPage: FC<PriceCategoryPageProps> = ({}) => {
  const { search, setSearch } = useContext(SearchContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [mounted, setMounted] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(30);
  const [pagination, setPagination] = useState<PaginationResponse>();
  const [productCategories, setPriceCategories] = useState<PriceCategory[]>(
    []
  );
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const [selectedPriceCategory, setSelectedPriceCategory] =
    useState<PriceCategory>();

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!mounted) return;
    fetchData();
  }, [mounted, search, page, size]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await getPriceCategories({ page, size, search });
      const resJson = await res.json();
      //   console.log(data);
      setPriceCategories(resJson.data.items);
      setPagination(getPagination(resJson.data));
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

    const removePriceCategory = async (priceCategory: PriceCategory) => {
      try {
        setIsLoading(true);
        if (
          window.confirm(
            `Are you sure you want to delete priceCategory with name ${priceCategory.name}?`
          )
        ) {
          await deletePriceCategory(priceCategory.id!);
          fetchData();
        }
      } catch (error) {
        errorToast(`${error}`);
      } finally {
        setIsLoading(false);
      }
    };
  
const savePriceCategory = async (priceCategory: PriceCategory) => {
  try {
    setIsLoading(true);
    if (selectedPriceCategory) {
      await updatePriceCategory(selectedPriceCategory.id!, priceCategory);
    } else {
      await createPriceCategory(priceCategory);
    }
    setModalFormOpen(false);
    setSelectedPriceCategory(undefined);
    fetchData();
  } catch (error) {
    errorToast(`${error}`);
  } finally {
    setIsLoading(false);
  }
}
  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">Price Category</h1>
      {/* button */}
      <div>
        {/* <IconButton
          size="sm"
          appearance="primary"
          color="green"
          icon={<PlusIcon />}
          onClick={() => setModalFormOpen(true)}
        >
          Create Price Category
        </IconButton> */}
      </div>
    </div>
  );
  return (
    <MainLayout header={renderHeader()}>
      <Table minHeight={700} data={productCategories} onRowClick={(data, i) => {}}>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(rowData) => <div>{(page - 1) * size + productCategories.indexOf(rowData as PriceCategory) + 1}</div>}
          </Cell>
        </Column>

        <Column width={200} resizable fixed>
          <HeaderCell>Name</HeaderCell>
          <Cell>{(rowData) => <div className="hover:underline cursor-pointer font-semibold " onClick={() => {
            // setSelectedPriceCategory(rowData as PriceCategory)
            // setModalFormOpen(true)
          }}>{rowData.name}</div>}</Cell>
        </Column>

        <Column width={600} resizable>
          <HeaderCell>Description</HeaderCell>
          <Cell dataKey="description" />
        </Column>

       
        <Column width={200} resizable>
          <HeaderCell>Action</HeaderCell>
          <Cell>
            {/* {(rowData) => (
              <BsTrash3
                className="text-red-500 hover:text-red-800"
                size={16}
                onClick={() => removePriceCategory(rowData as PriceCategory)}
              />
            )} */}
          </Cell>
        </Column>
      </Table>
      <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={pagination?.total ?? 0}
          limitOptions={[10, 30, 50]}
          limit={pagination?.size}
          activePage={pagination?.page}
          onChangePage={setPage}
          onChangeLimit={setSize}
        />
      </div>
      <PriceCategoryForm
        priceCategory={selectedPriceCategory}
        open={modalFormOpen}
        onClose={() => {
          setModalFormOpen(false);
          setSelectedPriceCategory(undefined);
        }}
        onSubmit={savePriceCategory}
      />
    </MainLayout>
  );
};
export default PriceCategoryPage;
